<template>
  <div class="lv_flexalign_center act_layout">
    <div @click="remove" class="act_button">复制选中</div>
  </div>
</template>

<script>
export default {
  props: ["selectedMaterial"],
  methods: {
    remove() {
      if (this.selectedMaterial) {
        this.$bus.$emit("copy", this.selectedMaterial.id);
      }
    },
  },
};
</script>